"use client";

import { useEffect, useRef, startTransition } from "react";
import { logoutAction } from "./actions";

const INACTIVITY_LIMIT = 15 * 60 * 1000; // 500 minutes before auto-logout

export function InactivityLogout() {
    const timer = useRef<NodeJS.Timeout | null>(null);

    const performLogout = () => {
        localStorage.setItem("logout", Date.now().toString());

        startTransition(() => {
            logoutAction();
        });
    };

    const resetTimer = () => {
        if (timer.current) clearTimeout(timer.current);

        timer.current = setTimeout(performLogout, INACTIVITY_LIMIT);
    };

    useEffect(() => {
        const activityEvents = [
            "mousemove",
            "mousedown",
            "keydown",
            "scroll",
            "touchstart",
            "focus"
        ];

        activityEvents.forEach(e =>
            window.addEventListener(e, resetTimer)
        );

        const onStorage = (e: StorageEvent) => {
            if (e.key === "logout") {
                startTransition(() => {
                    logoutAction();
                });
            }
        };

        window.addEventListener("storage", onStorage);

        resetTimer();

        return () => {
            if (timer.current) clearTimeout(timer.current);
            activityEvents.forEach(e =>
                window.removeEventListener(e, resetTimer)
            );
            window.removeEventListener("storage", onStorage);
        };
    }, []);

    return null;
}
